import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class DragDropService {
    private draggingSubject = new BehaviorSubject<boolean>(false);
    isDragging$ = this.draggingSubject.asObservable();

    setDragging(value: boolean) {
        this.draggingSubject.next(value);
    }
}
